import React from 'react';
import { SvgIcon } from '../../';
function InfoIcon(props) {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 24 24" },
        React.createElement("g", null,
            React.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "none" }),
            React.createElement("circle", { cx: "12", cy: "12", r: "11.5", fill: "none", stroke: "currentColor" })),
        React.createElement("g", { style: { isolation: 'isolate' } },
            React.createElement("text", { transform: "translate(10 18)", style: { isolation: 'isolate' }, fontSize: "17px", fill: "currentColor", fontFamily: "Roboto-Medium, Roboto", fontWeight: "500" }, "i"))));
}
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map